import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { NotificationCrudIndex } from './crud-index/notification.component';
import { FormsModule } from '@angular/forms';
import { TableResponsiveModule } from "src/app/shared/components/table-responsive/table-responsive.module";
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';

@NgModule({
  declarations: [
    NotificationCrudIndex,
  ],
  imports: [
    FormsModule,
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    TableResponsiveModule
],
exports: [
  NotificationCrudIndex
]

})
export class NotificationsModalModule { }
